import React, { useState, useEffect } from 'react';

import Header from 'on_web/components/shared/Menu/Header/Header';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';
import StepProgressIndicator from 'on_web/components/shared/StepProgressIndicator/StepProgressIndicator';

import { APP_SECTION_DISEASE_HISTORY } from 'colours';
import Question from 'on_web/components/shared/Question/Question';
import UserProfileContext from 'on_web/context/userProfileContext';
import { getSymptomsQuestions } from 'on_web/helpers/questions';

import { useTranslation } from 'react-i18next';

function DiseasesStep6(props) {
  const context = React.useContext(UserProfileContext);

  const { t } = useTranslation();
  const texts = getSymptomsQuestions(t);

  const [selectedBreathShortness, setSelectedBreathShortness] = useState(
    context && context.covidSymptopms
      ? context.covidSymptopms.breath_shortness
      : undefined
  );
  const [selectedFever, setSelectedFever] = useState(
    context && context.covidSymptopms ? context.covidSymptopms.fever : undefined
  );
  const [selectedCough, setSelectedCough] = useState(
    context && context.covidSymptopms ? context.covidSymptopms.cough : undefined
  );
  const [selectedBodyPain, setSelectedBodyPain] = useState(
    context && context.covidSymptopms
      ? context.covidSymptopms.body_pain
      : undefined
  );
  const [selectedDiarrhea, setSelectedDiarrhea] = useState(
    context && context.covidSymptopms
      ? context.covidSymptopms.diarrhea
      : undefined
  );
  const [selectedRunnyNose, setSelectedRunnyNose] = useState(
    context && context.covidSymptopms
      ? context.covidSymptopms.runny_nose
      : undefined
  );
  const [selectedSoreThroat, setSelectedSoreThroat] = useState(
    context && context.covidSymptopms
      ? context.covidSymptopms.sore_throat
      : undefined
  );
  const [selectedHeadache, setSelectedHeadache] = useState(
    context && context.covidSymptopms
      ? context.covidSymptopms.headache
      : undefined
  );
  const [selectedMemoryLoss, setSelectedMemoryLoss] = useState(
    context && context.covidSymptopms
      ? context.covidSymptopms.memory_loss
      : undefined
  );
  const [selectedSmellLoss, setSelectedSmellLoss] = useState(
    context && context.covidSymptopms
      ? context.covidSymptopms.smell_loss
      : undefined
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const onClickNext = () => {
    const covidSymptopms = context ? context.covidSymptopms : null;

    if (props.onClickNext && covidSymptopms) {
      covidSymptopms.body_pain = selectedBodyPain;
      covidSymptopms.breath_shortness = selectedBreathShortness;
      covidSymptopms.cough = selectedCough;
      covidSymptopms.diarrhea = selectedDiarrhea;
      covidSymptopms.fever = selectedFever;
      covidSymptopms.headache = selectedHeadache;
      covidSymptopms.memory_loss = selectedMemoryLoss;
      covidSymptopms.runny_nose = selectedRunnyNose;
      covidSymptopms.smell_loss = selectedSmellLoss;
      covidSymptopms.sore_throat = selectedSoreThroat;
      props.onClickNext(covidSymptopms);
    }
  };

  return (
    <React.Fragment>
      <Header />
      {(context == null || context.editMode !== true) && (
        <StepProgressIndicator
          showBasicQuestions={context.showBasicQuestions}
          selectedSlideIx={
            process.env.REACT_APP_HIDE_DNA_SECTION !== 'true' ? 3 : 2
          }
        />
      )}

      <Question
        sectionTitle={t(
          'onboarding.diseasesSection.diseasesStep5.sectionTitle1'
        )}
        pointSelectionTitle={t(
          'onboarding.diseasesSection.diseasesStep5.pointSelectionTitle1'
        )}
        onAnswer={val => setSelectedBreathShortness(val)}
        pointSelection={{
          answers: texts,
          color: APP_SECTION_DISEASE_HISTORY,
          textOnBothSides: true,
          selectedIx: selectedBreathShortness,
          tag: 'breath',
        }}
      />

      <Question
        pointSelectionTitle={t(
          'onboarding.diseasesSection.diseasesStep5.pointSelectionTitle2'
        )}
        onAnswer={val => setSelectedFever(val)}
        pointSelection={{
          answers: texts,
          color: APP_SECTION_DISEASE_HISTORY,
          textOnBothSides: true,
          selectedIx: selectedFever,
          tag: 'fever',
        }}
      />

      <Question
        pointSelectionTitle={t(
          'onboarding.diseasesSection.diseasesStep5.pointSelectionTitle3'
        )}
        onAnswer={val => setSelectedCough(val)}
        pointSelection={{
          answers: texts,
          color: APP_SECTION_DISEASE_HISTORY,
          textOnBothSides: true,
          selectedIx: selectedCough,
          tag: 'cough',
        }}
      />

      <Question
        pointSelectionTitle={t(
          'onboarding.diseasesSection.diseasesStep5.pointSelectionTitle4'
        )}
        onAnswer={val => setSelectedBodyPain(val)}
        pointSelection={{
          answers: texts,
          color: APP_SECTION_DISEASE_HISTORY,
          textOnBothSides: true,
          selectedIx: selectedBodyPain,
          tag: 'bodypain',
        }}
      />

      <Question
        pointSelectionTitle={t(
          'onboarding.diseasesSection.diseasesStep5.pointSelectionTitle5'
        )}
        onAnswer={val => setSelectedDiarrhea(val)}
        pointSelection={{
          answers: texts,
          color: APP_SECTION_DISEASE_HISTORY,
          textOnBothSides: true,
          selectedIx: selectedDiarrhea,
          tag: 'diarrhea',
        }}
      />

      <Question
        pointSelectionTitle={t(
          'onboarding.diseasesSection.diseasesStep5.pointSelectionTitle6'
        )}
        onAnswer={val => setSelectedRunnyNose(val)}
        pointSelection={{
          answers: texts,
          color: APP_SECTION_DISEASE_HISTORY,
          textOnBothSides: true,
          selectedIx: selectedRunnyNose,
          tag: 'runnynose',
        }}
      />

      <Question
        pointSelectionTitle={t(
          'onboarding.diseasesSection.diseasesStep5.pointSelectionTitle7'
        )}
        onAnswer={val => setSelectedSoreThroat(val)}
        pointSelection={{
          answers: texts,
          color: APP_SECTION_DISEASE_HISTORY,
          textOnBothSides: true,
          selectedIx: selectedSoreThroat,
          tag: 'sorethroat',
        }}
      />

      <Question
        pointSelectionTitle={t(
          'onboarding.diseasesSection.diseasesStep5.pointSelectionTitle8'
        )}
        onAnswer={val => setSelectedHeadache(val)}
        pointSelection={{
          answers: texts,
          color: APP_SECTION_DISEASE_HISTORY,
          textOnBothSides: true,
          selectedIx: selectedHeadache,
          tag: 'headache',
        }}
      />

      <Question
        pointSelectionTitle={t(
          'onboarding.diseasesSection.diseasesStep5.pointSelectionTitle9'
        )}
        onAnswer={val => setSelectedMemoryLoss(val)}
        pointSelection={{
          answers: texts,
          color: APP_SECTION_DISEASE_HISTORY,
          textOnBothSides: true,
          selectedIx: selectedMemoryLoss,
          tag: 'memoryloss',
        }}
      />

      <Question
        pointSelectionTitle={t(
          'onboarding.diseasesSection.diseasesStep5.pointSelectionTitle10'
        )}
        onAnswer={val => setSelectedSmellLoss(val)}
        pointSelection={{
          answers: texts,
          color: APP_SECTION_DISEASE_HISTORY,
          textOnBothSides: true,
          selectedIx: selectedSmellLoss,
          tag: 'smellloss',
        }}
      />

      <StickyNavigation
        onClickNext={() => onClickNext()}
        onClickBack={props.onClickBack}
        nextButtonDisabled={
          selectedBreathShortness == null ||
          selectedFever == null ||
          selectedCough == null ||
          selectedBodyPain == null ||
          selectedDiarrhea == null ||
          selectedRunnyNose == null ||
          selectedSoreThroat == null ||
          selectedHeadache == null ||
          selectedMemoryLoss == null ||
          selectedSmellLoss == null
        }
        editMode={context && context.editMode}
      />
    </React.Fragment>
  );
}

export default DiseasesStep6;
